import { transformMedia } from "@/util/mediaHelper.v2.ts";

/*
Determines if an object is a media object by checking if it
has all the required keys of a media object
 */
function isMediaObject(obj) {
  if (!obj) {
    return false;
  }

  return ["_id", "uuid", "url", "mimeType", "isExternal", "metadata"].every(
    (key) => {
      // only supported in chrome 93 or later
      if ("hasOwn" in Object) {
        return Object.hasOwn(obj, key) && typeof obj[key] !== "undefined";
      }
      return (
        Object.prototype.hasOwnProperty.call(obj, key) &&
        typeof obj[key] !== "undefined"
      );
    }
  );
}
/*
Recursively applies enhanced media to media objects.
 */
function recursivelyEnhanceMedia(data) {
  if (Array.isArray(data)) {
    return data.map(recursivelyEnhanceMedia);
  }
  if (typeof data === "object" && data !== null) {
    if (isMediaObject(data)) {
      return transformMedia(data);
    }
    const newData = {};
    Object.keys(data).forEach((key) => {
      newData[key] = recursivelyEnhanceMedia(data[key]);
    });
    return newData;
  }
  return data;
}

export { recursivelyEnhanceMedia, isMediaObject };
